/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import isNil from 'lodash/isNil';
import ceil from 'lodash/ceil';
import { types } from '../actions/billing';
import { combineAPIReducers } from './api';
import { APIStatus } from '../actions/api';

function planStateCreator(api) {
  const { response, status, error } = api;
  if (APIStatus.success(status)) {
    const expired = (
      !isNil(response.svcExpire) &&
      response.svcExpire < 0.001);
    const remaining = (
      isNil(response.svcExpire)
      ? 0
      : ceil(response.svcExpire));
    return {
      data: {
        ...response,
        expired,
        remaining,
      },
      status: APIStatus.name(status),
      error,
    };
  }

  return {
    data: {},
    status: APIStatus.name(status),
    error,
  };
}

export default combineAPIReducers(types, {
  plan: planStateCreator,
});




// WEBPACK FOOTER //
// ./src/redux/reducers/billing.js